import React from "react";
import { Routes, Route } from "react-router-dom";
import MainLayout from "../components/MainLayout";
import Home from "../pages/Home/Home";
import NotFound from "../components/NotFound/NotFound";
import ContactUs from "../pages/ContactUs/ContactUs";
import AboutUs from "../pages/AboutUs/AboutUs.jsx";
import SoftwareDevelopment from "../pages/ServicesPages/SoftwareDevelopment/SoftwareDevelopment.jsx";
import FullStackDev from "../pages/ServicesPages/FullStackDev/FullStackDev.jsx";
import WebDevelopment from "../pages/ServicesPages/WebDevelopment/WebDevelopment.jsx";
import UIUXDevelopment from "../pages/ServicesPages/UIUXDevelopment/UIUXDevelopment.jsx";
import AppDevelopment from "../pages/ServicesPages/AppDevelopment/AppDevelopment.jsx";
import Portfolios from "../pages/Portfolios/Portfolios.jsx";
import PortfolioDetail from "../pages/Portfolios/PortfolioDetail/PortfolioDetail.jsx";
import GetEstimate from "../pages/GetEstimate/GetEstimate.jsx";

const AppRoutes = () => {
  return (
    <Routes>
      {/* Layout wrapper */}
      <Route element={<MainLayout />}>
        <Route path="/" element={<Home />} />
        <Route path="/contact-us" element={<ContactUs />} />
        <Route path="/about-us" element={<AboutUs />} />
        <Route path="/software-development" element={<SoftwareDevelopment />} />
        <Route path="/fullstack-development" element={<FullStackDev />} />
        <Route path="/web-development" element={<WebDevelopment />} />
        <Route path="/uiux-development" element={<UIUXDevelopment />} />
        <Route path="/app-development" element={<AppDevelopment />} />
        <Route path="/portfolios" element={<Portfolios />} />
        <Route path="/portfolio/:id" element={<PortfolioDetail />} />
          
      </Route>

      {/* 404 page */}
      <Route path="*" element={<NotFound />} />
       <Route path="/get-estimate" element={<GetEstimate />} />
    </Routes>
  );
};

export default AppRoutes;
